import { useEffect, useRef, type RefObject } from 'react'

const useMessageObserve = (
  callback: basic.BasicFunc,
  messageRef?: RefObject<HTMLDivElement | null>
) => {
  const currentCallback = useRef(callback)
  currentCallback.current = callback

  useEffect(() => {
    const message = messageRef?.current
    if (!message) {
      return
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          currentCallback.current()
        }
      })
    }, {
      threshold: 0.1,
    })

    observer.observe(message)
    return () => {
      observer.disconnect()
    }
  }, [messageRef])
}

export default useMessageObserve